
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 13v1.5l3.063-2.281A.987.987 0 019.655 12H14c.531 0 1-.438 1-1V2c0-.531-.469-1-1-1H2c-.563 0-1 .469-1 1v9c0 .563.438 1 1 1h3c.531 0 1 .469 1 1zM2 0h12c1.094 0 2 .906 2 2v9c0 1.125-.906 2-2 2H9.656l-3.875 2.906c-.156.125-.343.125-.531.063A.514.514 0 015 15.5V13H2c-1.125 0-2-.875-2-2V2C0 .906.875 0 2 0zm6.5 3.25v.563c.25.03.5.093.75.156.25.062.406.344.344.594-.063.28-.344.437-.625.375a6.203 6.203 0 00-1-.188c-.25 0-.532.063-.719.188-.188.093-.25.218-.25.406 0 .093.031.187.219.312.218.125.5.219.906.344h.031c.344.094.781.25 1.125.438.375.25.688.625.719 1.218 0 .594-.313 1.032-.719 1.282-.25.156-.531.25-.781.28v.532c0 .281-.25.5-.5.5a.494.494 0 01-.5-.5v-.531c-.375-.063-.688-.188-.969-.281a.58.58 0 00-.218-.063A.531.531 0 016 8.25c.094-.281.375-.406.656-.344.063.032.125.063.219.094.406.125.75.25 1.125.281.281 0 .563-.062.75-.187.156-.094.25-.219.219-.438 0-.125-.031-.25-.219-.343-.219-.157-.531-.25-.906-.375H7.78c-.343-.094-.75-.22-1.093-.438C6.313 6.281 6 5.906 6 5.344c0-.594.313-1.032.719-1.282.25-.125.5-.218.781-.25V3.25c0-.25.219-.5.5-.5.25 0 .5.25.5.5z","fill":"#212121"}})])
          )
        }
      }
    